import { useState } from "react";
import { api, apiError } from "../lib/api";
import { Send } from "lucide-react";
import { toast } from "sonner";

export function ReplyThread({ comment, onChanged }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post(`/coaching-comments/${comment.id}/reply`, { text });
      setText("");
      onChanged();
    } catch (e) { toast.error(apiError(e)); }
    setSending(false);
  };

  return (
    <div className="mt-3 space-y-2">
      {(comment.replies || []).map((r) => (
        <div key={r.id} data-testid={`coaching-reply-${r.id}`}
          className={`text-sm rounded-lg px-3 py-2 ${r.role === "aide" ? "bg-emerald-50 text-emerald-900" : "bg-sky-50 text-sky-900"}`}>
          <span className="text-[11px] font-bold uppercase tracking-wide mr-2 opacity-70">{r.user_name} · {r.created_at.slice(0, 10)}</span>
          {r.text}
        </div>
      ))}
      <div className="flex gap-2">
        <input data-testid={`reply-input-${comment.id}`} value={text} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Reply briefly…"
          className="flex-1 rounded-full border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
        <button data-testid={`reply-send-btn-${comment.id}`} onClick={send} disabled={sending || !text.trim()}
          className="p-2.5 rounded-full bg-emerald-700 text-white hover:bg-emerald-800 transition-colors duration-150 disabled:opacity-50">
          <Send size={14} />
        </button>
      </div>
    </div>
  );
}
